var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"unique-opened":"","background-color":"#001529","text-color":"#b3b9bf","active-text-color":"#fff","mode":"vertical"}},[_c('SidebarItem',{attrs:{"menus":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }